import { FaHome } from 'react-icons/fa';
import { MdAppRegistration } from 'react-icons/md';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CheckIcon from '@mui/icons-material/Check';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useContext } from 'react';
import ThemeOptionContext from '../../context/theme-option/ThemeOptionContext';
import { useLocalStorage } from '../../hooks/providers/useLocalStorage';
import UserContext from '../../context/user/UserContext';
import * as React from 'react';
import { Avatar, ButtonGroup, Divider, Menu, MenuItem, SwipeableDrawer, Typography } from '@mui/material';
import { useSessionStorage } from '../../hooks/providers/useSessionStorage';
import { useNavigate, useLocation } from 'react-router-dom';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import useWindowDimensions from '../../hooks/util/useWindowDimensions';
import MarkChatReadOutlinedIcon from '@mui/icons-material/MarkChatReadOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AddIcon from '@mui/icons-material/Add';

import {
  AppMenuStyled,
  UserMenu,
  MenuStyled,
  AppMenuInfo,
  AppMenuConfig,
  MenuButton,
  ConfigButton,
} from './AppMenu.styled';
import InstallPWA from '../InstallPWA/InstallPWA';
import { hasAccessTo } from '../../util/hasAccessTo';

const hoverStyle = { '&:hover': { backgroundColor: '#1a817a', borderRadius: '10px' } };
const activeStyle = { borderBottom: '3px solid #1a817a', '&:hover': { backgroundColor: '#1a817a' } };

const AppMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sessionStorage = useSessionStorage();
  const [anchorUserMenu, setAnchorUserMenu] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorUserMenu);
  const { state: userState, setState: setUserState } = useContext(UserContext);
  const { width } = useWindowDimensions();
  const [isScreenSmall, setIsScreenSmall] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [toogleMenuPoint] = React.useState(550);
  const { state: themeState, setState: setThemeState } = useContext(ThemeOptionContext);
  const localStorage = useLocalStorage();

  const TimeClocking = localStorage.getItem('useTimeClocking');

  React.useEffect(() => {
    if (width < toogleMenuPoint) {
      setIsScreenSmall(true);
      setIsMenuOpen(false);
    } else {
      setIsScreenSmall(false);
    }
  }, [width]);

  const toggleTheme = (isDark: boolean) => {
    localStorage.setItem('isDark', !themeState.isDark);
    setThemeState(state => {
      return {
        ...state,
        isDark,
      };
    });
  };

  const getAvatar = (): string => {
    try {
      const firstLetter = userState.name?.split('')[0]?.toUpperCase();
      const lastLetter = userState.name
        ?.split(' ')
      [userState.name?.split(' ').length - 1]?.split('')[0]
        ?.toUpperCase();
      return `${firstLetter}${lastLetter}`;
    } catch (error) {
      return userState.name?.split('')[0]?.toUpperCase();
    }
  };

  const getName = () => {
    return userState.name?.split(' ')[0];
  };

  const logout = () => {
    sessionStorage.clear();
    setUserState({
      expires_in: 0,
      username: '',
      access_token: '',
      refresh_token: '',
      name: '',
      email: '',
      tenantDomain: '',
      logged: false,
      typeAuth: '',
      fullUser: false,
      rhUser: false,
      managerUser: false,
      resources: [''],
      resourcesWithActions: {},
    });
    navigate('/login');
  };

  const toPath = (path: string, popup?: any): void => {
    navigate(path);
    popup?.close();
    setIsMenuOpen(false);
  };

  const getMenu = () => {
    return (
      <>
        <div style={{display: 'flex', alignItems: 'center' }} >
          <Typography sx={{ color: '#208f87', fontWeight: '600', margin: '8px' }}>Atestado Digital</Typography>
          <Divider orientation="vertical" sx={{borderColor: 'white', fontWeight: '10px', margin: '0px 8px 0px 8px'}}/>
        </div>
        <MenuButton
          variant="text"
          sx={{ color: '#fff', fontWeight: 600, ...hoverStyle, ...(location.pathname === '/home' && activeStyle) }}
          onClick={() => toPath('/home')}
          startIcon={<FaHome style={{ fontSize: '15px', marginRight: '-3px' }} />}
        >
          Home
        </MenuButton>
        {hasAccessTo(["atestado-digital-gestor", "atestado-digital-rh", "atestado-digital-admin"], userState.resourcesWithActions) && (
          <PopupState variant="popover" popupId="demo-popup-menu">
            {popupState => (
              <>
                <MenuButton
                  variant="text"
                  {...bindTrigger(popupState)}
                  sx={{ color: '#fff', fontWeight: 600, ...hoverStyle, ...(['/collaborator', '/tipo-documento', '/modelo-mensagem', '/point-situation'].includes(location.pathname) && activeStyle) }}
                  startIcon={<MdAppRegistration style={{ marginRight: '-3px' }} />}
                  endIcon={popupState.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                >
                  Cadastros
                </MenuButton>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem onClick={() => toPath('/collaborator', popupState)}>Colaborador</MenuItem>
                  <MenuItem onClick={() => toPath('/tipo-documento', popupState)}>Tipo de Documento</MenuItem>
                  <MenuItem onClick={() => toPath('/modelo-mensagem', popupState)}>Modelos de Mensagem</MenuItem>
                  {TimeClocking && (
                    <MenuItem onClick={() => toPath('/point-situation', popupState)}>Situações de Ponto</MenuItem>
                  )}
                </Menu>
              </>
            )}
          </PopupState>
        )}
        <>
          {!TimeClocking ? (
            <MenuButton
              variant="text"
              sx={{ color: '#fff', fontWeight: 600, ...hoverStyle, ...(location.pathname === '/followup' && activeStyle) }}
              onClick={() => toPath('/followup')}
              startIcon={<MarkChatReadOutlinedIcon style={{ marginRight: '-3px' }} />}
            >
              Followup
            </MenuButton>
          ) : (
            <PopupState variant="popover" popupId="demo-popup-menu">
              {popupState => (
                <>
                  <MenuButton
                    variant="text"
                    {...bindTrigger(popupState)}
                    sx={{ color: '#fff', fontWeight: 600, ...hoverStyle, ...(['/followup', '/followup-point-control'].includes(location.pathname) && activeStyle) }}
                    startIcon={<MarkChatReadOutlinedIcon style={{ marginRight: '-3px' }} />}
                    endIcon={popupState.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  >
                    Followup
                  </MenuButton>
                  <Menu {...bindMenu(popupState)}>
                    <MenuItem onClick={() => toPath('/followup', popupState)}>Atestados</MenuItem>
                    <MenuItem onClick={() => toPath('/followup-point-control', popupState)}>Controle de Ponto</MenuItem>
                  </Menu>
                </>
              )}
            </PopupState>
          )}
        </>

        {hasAccessTo(['atestado-digital-gestor', 'atestado-digital-rh','atestado-digital-admin'], userState.resourcesWithActions) && (
          <MenuButton
            variant="text"
            sx={{ color: '#fff', fontWeight: 600, ...hoverStyle, ...(location.pathname === '/followup-report' && activeStyle) }}
            onClick={() => toPath('/followup-report')}
            startIcon={<AssessmentOutlinedIcon style={{ marginRight: '-3px' }} />}
          >
            Relatórios
          </MenuButton>
        )}
        {hasAccessTo(['cadastrar-documento-atestado-web'], userState.resourcesWithActions) && (
          <MenuButton
            variant="text"
            sx={{ color: '#fff', fontWeight: 600, ...hoverStyle, ...(location.pathname === '/cadastrar-documento' && activeStyle) }}
            onClick={() => toPath('/cadastrar-documento')}
            startIcon={<AddIcon style={{ marginRight: '-3px' }} />}
          >
            Novo documento
          </MenuButton>
        )}
      </>
    );
  };

  return (
    <AppMenuStyled logged={userState.logged}>
      <MenuStyled>
        {isScreenSmall ? (
          <>
            <MenuButton onClick={() => setIsMenuOpen(true)} sx={{ position: 'absolute', left: -25, top: -17.5 }}>
              <MenuIcon sx={{ color: '#ffff' }} />
            </MenuButton>
            <SwipeableDrawer
              anchor="left"
              open={isMenuOpen}
              onClose={() => setIsMenuOpen(false)}
              onOpen={() => setIsMenuOpen(true)}
              PaperProps={{
                sx: { 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  backgroundColor: '#454545',
                  padding: '16px 8px',
                  minWidth: '250px',
                },
              }}
            >
              {getMenu()}
            </SwipeableDrawer>
          </>
        ) : (
          getMenu()
        )}
      </MenuStyled>
      <AppMenuInfo>
        <MenuButton
          variant="text"
          color="inherit"
          id="menu-button"
          aria-controls={open ? 'menu-button' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={e => setAnchorUserMenu(e.currentTarget)}
          endIcon={anchorUserMenu ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        >
          <Avatar sx={{ bgcolor: 'gray', color: '#000' }}>{getAvatar()}</Avatar>
          {width > toogleMenuPoint && <span style={{ marginLeft: '10px', fontWeight: 600 }}>{getName()}</span>}
        </MenuButton>
        <UserMenu
          id="menu-button"
          anchorEl={anchorUserMenu}
          open={open}
          onClose={() => setAnchorUserMenu(null)}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={() => setAnchorUserMenu(null)}>
            <ButtonGroup variant="text" aria-label="outlined primary button group" color="inherit">
              <MenuButton startIcon={themeState.isDark ? null : <CheckIcon />} onClick={() => toggleTheme(false)}>
                Claro
              </MenuButton>
              <MenuButton startIcon={!themeState.isDark ? null : <CheckIcon />} onClick={() => toggleTheme(true)}>
                Escuro
              </MenuButton>
            </ButtonGroup>
          </MenuItem>
          <InstallPWA type="menu" />
          {userState.typeAuth !== 'platform' && (
            <MenuItem
              onClick={() => {
                setAnchorUserMenu(null);
                logout();
              }}
            >
              Sair
            </MenuItem>
          )}
        </UserMenu>
      </AppMenuInfo>

      {hasAccessTo(['atestado-digital-admin'], userState.resourcesWithActions) && (
        <AppMenuConfig>
          <PopupState variant="popover" popupId="demo-popup-menu">
            {popupState => (
              <>
                <ConfigButton
                  variant="text"
                  {...bindTrigger(popupState)}
                  sx={{ color: '#fff' }}
                  startIcon={<SettingsOutlinedIcon style={{ marginRight: '-15px' }} />}
                  endIcon={popupState.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                ></ConfigButton>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem onClick={() => toPath('/tenant', popupState)}>Parâmetros da Empresa</MenuItem>
                  <MenuItem onClick={() => toPath('/user', popupState)}>Manutenção de Usuários</MenuItem>
                  <MenuItem onClick={() => toPath('/logs', popupState)}>Logs</MenuItem>
                </Menu>
              </>
            )}
          </PopupState>
        </AppMenuConfig>
      )}

    </AppMenuStyled>
  );
};

export default AppMenu;
